import React from "react";

const Arrow = ({ left, delay, size }) => {
  return (
    <div
      className="arrow"
      style={{
        left: `${left}%`,
        animationDelay: `${delay}s`,
        borderLeftWidth: `${size}px`,
        borderRightWidth: `${size}px`,
        borderTopWidth: `${size * 2}px`,
      }}
    >
      <div
        className="arrow-shaft"
        style={{
          width: `${size / 2}px`,
          height: `${size * 3}px`,
          marginTop: `${size * 2}px`,
          animationDelay: `${delay}s`,
        }}
      ></div>
    </div>
  );
};

export default Arrow;
